import CardDots from "@/Components/DataDisplayCompoants/CardDots";

interface ThumbSlideProps {
  title: string;
  description: string;
  bgColor?: "blue" | "green";
  isActive: boolean;
}

const ThumbSlide: React.FC<ThumbSlideProps> = ({
  bgColor,
  title,
  description,
}) => {
  const afterBg =
    bgColor === "blue"
      ? "after:bg-[url(/images/slider/blue-slide.png)]"
      : "after:bg-[url(/images/slider/green-slide.png)]";
  const beforeBg =
    bgColor === "blue"
      ? "lg:before:bg-[url(/images/slider/blue-shard.webp)] before:bg-[url(/images/slider/blue-shard-mobile.svg)] before:will-change-transform"
      : "lg:before:bg-[url(/images/slider/green-shard.webp)] before:bg-[url(/images/slider/green-shard-mobile.svg)] before:will-change-transform";
  const colorClass = bgColor === "blue" ? "bg-blue-50" : "bg-green-50";

  const trimToTwoLines = (text: string = "", maxWords = 5) => {
    const words = text.trim().split(" ");
    return words.length > maxWords
      ? words.slice(0, maxWords).join(" ") + "..."
      : text;
  };

  return (
    <div className="w-full h-full cursor-pointer">
      <div
        className={`relative lg:aspect-square xl:px-3 px-6 xl:py-[35px] py-6 xl:pt-[18px] pt-[35px] ${colorClass} flex flex-col justify-end items-start
          ${afterBg} after:content-[''] after:absolute lg:after:w-[58px] after:w-[44px] lg:after:h-[115px] after:h-[85px] after:max-h-[90%] after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
          ${beforeBg} before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center`}
      >
        <CardDots />
        <p className="text-heading-6 font-bold text-primary-text w-full relative z-10">
          {title}
        </p>
        <p className="text-subtitle-3 font-regular text-secondary-text relative z-10 opacity-70 mt-3 lg:hidden block capitalize line-clamp-2 overflow-hidden" title={description ?? ""}>
          {trimToTwoLines(description, 10)}
        </p>
      </div>
      <div className="hidden lg:block">
        <p className="text-subtitle-3 font-regular text-secondary-text-white relative z-10 opacity-70 mt-3 line-clamp-2 overflow-hidden capitalize" title={description ?? ""}>
          {trimToTwoLines(description)}
        </p>
      </div>
    </div>
  );
};
export default ThumbSlide;
